module.exports = __webpack_public_path__ + "img/CV.Pavement.Concrete_Carriageway.Adopted_Carriageway,_Main_Local_Road,_Good_existing_ground.6a51cce6.png";